import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';

@Injectable({
  providedIn: 'root',
})
export class G4Service {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiUrl: string;

  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/admin/g4';
  }

  public getG4Customer(customerNumber: number): Observable<GetG4CustomerResponse> {
    const url = `${this.apiUrl}/customers/${customerNumber}`;
    return this.http.get<GetG4CustomerResponse>(url);
  }

  public getG4Account(accountNumber: number): Observable<GetG4AccountResponse> {
    const url = `${this.apiUrl}/accounts/${accountNumber}`;
    return this.http.get<GetG4AccountResponse>(url);
  }

  public getG4BusinessAccount(accountNumber: number): Observable<GetG4BusinessAccountResponse> {
    const url = `${this.apiUrl}/business-accounts/${accountNumber}`;
    return this.http.get<GetG4BusinessAccountResponse>(url);
  }

  public getG4Agreement(agreementNumber: number): Observable<GetG4AgreementResponse> {
    const url = `${this.apiUrl}/agreements/${agreementNumber}`;
    return this.http.get<GetG4AgreementResponse>(url);
  }
}

export interface GetG4CustomerResponse {
  customer_number: number;
  name: string;
  email: string;
  phone_number: string;
  is_cpr_registered: boolean;
}

export interface GetG4AccountResponse {
  customer_name: string;
  address: string;
  phone_number: string;
}

export interface GetG4BusinessAccountResponse {
  customer_number: number;
  account_name: string;
  customer_name: string;
  account_purpose: string;
}

export interface GetG4AgreementResponse {
  account_number: number | null;
  account_name: string;
  account_purpose: string;
  email_address: string;
}
